import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CustomButton from "../../components/UI/Buttons/CustomButton";
import RightArrow from "../../components/UI/Icons/RightArrow";
import { NON_AUTH_ROUTE } from "../App/routes";

const EmailVerified: FC = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    const decodedEmail: string | null = localStorage.getItem("verified_email");

    if (decodedEmail) {
      const email: string = decodeURIComponent(decodedEmail);
      setEmail(email);
    }
  }, [setEmail]);

  const handleRedirectLogin = () => {
    navigate(NON_AUTH_ROUTE.LOGIN);
  };

  return (
    
      <div className="d-flex flex-column gap-30 gap-mobile-20 align-items-center">
        <div className="d-flex flex-column gap-15 align-items-center">
          <svg
            width="60"
            height="61"
            viewBox="0 0 60 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="0.5" width="60" height="60" rx="30" fill="#C0F2EE" />
            <circle
              cx="30.0002"
              cy="30.5007"
              r="15.1667"
              stroke="black"
              strokeWidth="3"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.2803 25.7221C37.574 26.0173 37.5729 26.4946 37.2777 26.7884L27.429 36.59C27.1349 36.8827 26.6594 36.8827 26.3653 36.59L21.8886 32.1347C21.5935 31.841 21.5923 31.3636 21.8861 31.0684C22.1798 30.7733 22.6572 30.7721 22.9523 31.0659L26.8972 34.9918L36.214 25.7196C36.5092 25.4258 36.9865 25.427 37.2803 25.7221Z"
              fill="black"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="fs-16 fw-400 text-black text-center">
            Thanks for verifying your email <br />
            <span className="fw-700 text-break">{email}</span>
          </div>
        </div>
        <div className="d-flex">
          <CustomButton
            variant="primary"
            type="submit"
            className="btn-theme bg-teal text-black w-250px"
            onClick={handleRedirectLogin}
          >
            Get Started
            <RightArrow color={"black"} />
          </CustomButton>
        </div>
      </div>
   
  );
};

export default EmailVerified;